import { takeLatest, all, takeEvery } from 'redux-saga/effects';
import {
  DELETE_MEDIA,
  FETCH_PROJECTS,
  GRANT_PERMISSIONS,
  IMPORT_PROJECT,
  LAUNCH_ADS,
  UPDATE_PROJECT,
  UPLOAD_MEDIA,
  UPLOAD_VIDEO,
  FETCH_PROJECT_JOBS,
  START_JOBS_REFRESH,
  GRANT_CUSTOM_AUDIENCES,
  LAUNCH_GOOGLE_ADS,
  DISPLAY_ARCHIVED_PROJECTS,
  FETCH_SESSIONS,
  CREATE_SESSION,
  DELETE_SESSIONS,
  GET_PROJECT_FB_ADS_ACCOUNTS,
  PROJECT_SELECTED,
  GET_PROJECT_FB_PAGES,
  FETCH_PROJECT_MEDIA_SUCCESS,
  STOP_JOB,
  IMPORT_JOB_DATA,
  FORM_SELECTED,
  LAUNCH_BUDGET_OPT,
  ITERATION_UPDATED,
  FETCH_SESSIONS_FAILED,
  FETCH_SESSIONS_SUCCESS,
  GET_PROJECT_AUTO_SCALING_SETTING,
  UPDATE_AUTO_SCALING_SETTING,
  GET_PROJECT_PAYMENT_SETTING,
  UPDATE_PAYMENT_SETTING,
  ENABLE_PROJECT_MARKETING,
  DISABLE_PROJECT_MARKETING,
} from 'containers/App/constants';
import handleFetchProjects from './sagas/fetch-projects';
import handleLaunchAds from './sagas/launch-ads';
import handleUploadMedia from './sagas/upload-media';
import handleDeleteMedia from './sagas/delete-media';
import handleProjectImport from './sagas/import-project';
import handleUpdateProject from './sagas/update-project';
import handleGrantPermissions from './sagas/grant-permissions';
import handleUploadVideo from './sagas/upload-video';
import handleFetchProjectJobs from './sagas/fetch-project-jobs';
import handleJobsRefresh from './sagas/refresh-jobs';
import handleGrantCustomAudiences from './sagas/grant-custom-audiences';
import handleLaunch from './sagas/launch-google-ads';
import handleFetchSessions from './sagas/sessions';
import handleCreateSession from './sagas/create-session';
import handleSessionsDelete from './sagas/delete-sessions';
import handleFetchFacebookAdsAccounts from './sagas/fetch-facebook-ads-accounts';
import handleFetchProjectFacebookPages from './sagas/fetch-project-facebook-pages';
import handleFetchProjectMedia from './sagas/fetch-project-media';
import handleAspectRatio from './sagas/aspect-ratio';
import handleStopJob from './sagas/stop-job';
import handleRouteChange from './sagas/route-change';
import handleStatus from './sagas/get-project-status';
import handleOptimizationLaunch from './sagas/launch-budget-optimization';
import handleGetAutoScalingSetting from './sagas/get-project-auto-scaling-setting';
import handleUpdateAutoScaling from './sagas/update-auto-scaling-setting';
import handleGetPaymentSetting from './sagas/get-project-payment-setting';
import handleUpdatePaymentSetting from './sagas/update-payment-setting';
import handleEnableMarketing from './sagas/enable-marketing';
import handleDisableMarketing from './sagas/disable-marketing';
import localStorageSaveSettings from './sagas/localstorage-save-setting';

// Root saga
export default function* rootSaga() {
  yield all([
    takeLatest(UPLOAD_MEDIA, handleUploadMedia),
    takeLatest(
      [
        FETCH_PROJECTS,
        DISPLAY_ARCHIVED_PROJECTS,
        FETCH_SESSIONS_FAILED,
        FETCH_SESSIONS_SUCCESS,
      ],
      handleFetchProjects,
    ),
    takeLatest(LAUNCH_ADS, handleLaunchAds),
    takeLatest(DELETE_MEDIA, handleDeleteMedia),
    takeLatest(IMPORT_PROJECT, handleProjectImport),
    takeLatest(UPDATE_PROJECT, handleUpdateProject),
    takeLatest(GRANT_PERMISSIONS, handleGrantPermissions),
    takeLatest(PROJECT_SELECTED, handleFetchProjectMedia),
    takeLatest(UPLOAD_VIDEO, handleUploadVideo),
    takeLatest(FETCH_PROJECT_JOBS, handleFetchProjectJobs),
    takeLatest(START_JOBS_REFRESH, handleJobsRefresh),
    takeEvery(STOP_JOB, handleStopJob),
    takeLatest(GRANT_CUSTOM_AUDIENCES, handleGrantCustomAudiences),
    takeLatest(LAUNCH_GOOGLE_ADS, handleLaunch),
    takeLatest(FETCH_SESSIONS, handleFetchSessions),
    takeLatest(CREATE_SESSION, handleCreateSession),
    takeLatest(DELETE_SESSIONS, handleSessionsDelete),
    takeLatest(
      [GET_PROJECT_FB_ADS_ACCOUNTS, PROJECT_SELECTED],
      handleFetchFacebookAdsAccounts,
    ),
    takeLatest(
      [GET_PROJECT_FB_PAGES, PROJECT_SELECTED],
      handleFetchProjectFacebookPages,
    ),
    takeEvery(FETCH_PROJECT_MEDIA_SUCCESS, handleAspectRatio),
    takeLatest(IMPORT_JOB_DATA, handleRouteChange),
    takeLatest(
      [FORM_SELECTED, PROJECT_SELECTED, ITERATION_UPDATED],
      handleStatus,
    ),
    takeLatest(LAUNCH_BUDGET_OPT, handleOptimizationLaunch),
    takeLatest(GET_PROJECT_AUTO_SCALING_SETTING, handleGetAutoScalingSetting),
    takeLatest(UPDATE_AUTO_SCALING_SETTING, handleUpdateAutoScaling),
    takeLatest(UPDATE_PAYMENT_SETTING, handleUpdatePaymentSetting),
    takeLatest(GET_PROJECT_PAYMENT_SETTING, handleGetPaymentSetting),
    takeLatest(ENABLE_PROJECT_MARKETING, handleEnableMarketing),
    takeLatest(DISABLE_PROJECT_MARKETING, handleDisableMarketing),
    takeLatest(DISPLAY_ARCHIVED_PROJECTS, localStorageSaveSettings),
  ]);
}
